<template>
  <!-- Suggestions template -->
  <div v-if="type === 'suggestions'">
    <div class="suggestions clearfix">
      <div
        v-for="suggestion in content"
        :key="suggestion.id"
        class="suggestion"
        :class="{suggestionImage : suggestion.image != null}"
        @click="sendMessage(suggestion)"
      >
        {{suggestion}}
        <!-- <div v-if="suggestion.link != null">
          <a target="_blank" v-if="suggestion.image != null" :href="suggestion.link">
            <img :src="require(`@/assets/media/${ suggestion.image }`)" />
          </a>
          <a v-else target="_blank" :href="suggestion.link">{{ suggestion.title }}</a>
        </div>
        <div v-else-if="suggestion.image != null">
          <img :src="require(`@/assets/media/${ suggestion.image }`)" />
        </div>
        <div v-else>{{ suggestion }}</div>-->
      </div>
    </div>
    <!-- suggestions -->
  </div>

  <!-- Linkout template -->
  <div v-else-if="type === 'linkout'" class="outgoing-message message linkout">
    {{ title }}
    <a target="_blank" class="linkoutBtn" :href="content.url">
      {{ content.text }}
      <font-awesome-icon icon="arrow-right" />
    </a>
  </div>

  <!-- Upload template -->
  <div v-else-if="type === 'upload'" class="outgoing-message message upload">
    Carica il tuo {{ content }}
    <form>
      <input
        type="file"
        :name="content.toLowerCase()"
        :id="content.toLowerCase()"
        multiple
        max="5"
        @change="onFileChange"
      />
      <label :for="content.toLowerCase()">
        <font-awesome-icon v-if="files <= 0" icon="upload" />
        <font-awesome-icon v-if="files >= 1" icon="check" />
        <span v-if="files <= 0">Scegli un file...</span>
        <span v-if="files >= 1">Hai caricato {{ files }} file(s)</span>
      </label>
    </form>
  </div>

  <!-- Table Card -->
  <div v-else-if="type === 'tablecard'" class="message outgoing-message tablecard">
    {{ title }}
    <div class="tableContainer">
      <table>
        <thead>
          <tr>
            <th v-for="column in columns" :key="column.id">{{ column }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in content" :key="row.id">
            <td v-for="cell in row" :key="cell.id">{{ cell }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Typing template -->
  <div v-else-if="type === 'typing'" class="incoming-message message typing">
    <div class="typingContainer">
      <span class="typingDot"></span>
      <span class="typingDot"></span>
      <span class="typingDot"></span>
    </div>
  </div>

  <!-- Typing template -->
  <div v-else-if="type === 'html'" class="outgoing-message message" v-html="content"></div>

  <!-- Register -->
  <div v-else-if="type === 'register'" class="outgoing-message message register">
    {{content.title}}
    <div class="formContainer">
      <form>
        <div class="inputContainer">
          <input type="text" name="first_name" placeholder="Nome" v-model="firstname" />
        </div>
        <div class="inputContainer">
          <input type="text" name="last_name" placeholder="Cognome" v-model="lastname" />
        </div>
        <div class="inputContainer">
          <input type="email" name="email" placeholder="Email" v-model="email" />
        </div>
        <div class="inputContainer">
          <div class="new">
            <label class="option">
              <input type="hidden" name="gdpr" vlaue="0" />
              <input type="checkbox" name="gdpr" value="1" />
              <span class="check-box"></span>
              <p class="helpbox">{{ content.gdpr}}</p>
            </label>
          </div>
        </div>
        <div class="inputContainer">
          <div class="new">
            <label class="option">
              <input type="hidden" name="mrktg" vlaue="0" />
              <input type="checkbox" name="mrktg" value="1" />
              <span class="check-box"></span>
              <p class="helpbox">{{ content.marketing }}</p>
            </label>
          </div>
        </div>
        <div class="inputContainer">
          <input type="submit" value="Invia" />
        </div>
      </form>
    </div>
  </div>
  <!-- Simple template -->
  <div v-else :class="direction + '-message message'" v-html="content"></div>
</template>
<script>
export default {
  props: ["direction", "content", "type", "suggestions", "columns", "title"],
  name: "Simple",
  data() {
    return {
      files: 0,
      firstname: "",
      lastname: "",
      email: ""
    };
  },
  methods: {
    sendMessage: function(message) {
      this.$root.$emit("component_message", message);
    },
    onFileChange: function(e) {
      var files = e.target.files || e.dataTransfer.files;
      this.files = files.length;
    }
  }
};
</script>
<style>
.message {
  padding: 5px 14px;
  border-radius: 25px;
  min-width: 2vw;
  max-width: 100%;
  position: relative;
  margin-bottom: 14px;
}
.incoming-message {
  border-top-right-radius: 0px !important;
  margin-left: 8%;
  float: right;
  clear: left;
}
.incoming-message:after {
  content: "";
  display: block;
  /* background: #97bf0d; */
  position: absolute;
  width: 10px;
  height: 10px;
  top: 0px;
  right: -5px;
  border-bottom: 5px solid transparent;
  border-right: 5px solid transparent;
}
.outgoing-message {
  border-top-left-radius: 0px !important;
  margin-right: 8%;
  float: left;
  clear: right;
}
.outgoing-message:after {
  content: "";
  display: block;
  /* background: #97bf0d; */
  position: absolute;
  width: 10px;
  height: 10px;
  top: 0px;
  left: -5px;
  border-left: 5px solid transparent;
  border-bottom: 5px solid transparent;
}
/********* Suggestion **********/
.suggestions {
  clear: both;
  margin-bottom: 14px;
}
.suggestions .suggestion {
  float: left;
  border-radius: 25px;
  margin: 4px 2px;
  padding: 4px 9px;
  cursor: pointer;
}
.suggestions .suggestion a,
.suggestions .suggestion a:visited,
.suggestions .suggestion a:focus,
.suggestions .suggestion a:hover {
  text-decoration: none;
}
.suggestion img {
  max-width: 230px;
}
.suggestionImage {
  padding: 0px !important;
  background: transparent !important;
}
/********* Linkout **********/
.linkout a {
  display: block;
  width: fit-content;
  margin: 9px auto 5px;
  padding: 3px 11px;
  border-radius: 7px;
}
/********* Table **********/
.tablecard .tableContainer {
  overflow: auto;
  margin: 20px -14px 20px;
  max-height: 325px;
}
.tablecard th,
td {
  padding: 15px;
}
.tablecard table tr:not(:last-child) {
  border-bottom: 1px solid #97bf0d;
}
.tablecard table tr:nth-child(2n + 1) td {
  background: #666;
  color: #fff;
}
.tablecard table th:not(:last-child),
.tablecard table td:not(:last-child) {
  border-right: 1px solid #97bf0d;
}
/********** Upload ************/
.upload {
  min-height: 85px;
}
.upload form {
  margin: 3px auto 3px;
  height: 110px;
}
.upload input {
  width: 0.1px;
  height: 0.1px;
  overflow: hidden;
  z-index: -1;
}
.upload label {
  display: block;
  margin: auto;
  text-align: center;
}

.upload label i {
  font-size: 1.5rem;
  cursor: pointer;
  display: inline-block;
  padding: 10px 13px;
  display: block;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin: auto;
}
/***** Typing  *****/
.message.typing {
  height: 35px;
}
.typingContainer {
  width: 40px;
}
.typingDot {
  display: inline-block;
  width: 5px;
  height: 5px;
  background-color: #ebebeb;
  margin: 3px;
  border-radius: 50%;
  animation: typing 1.5s infinite;
}
.typingDot:nth-child(1) {
  animation-delay: 0;
}
.typingDot:nth-child(2) {
  animation-delay: 0.3s;
}
.typingDot:nth-child(3) {
  animation-delay: 0.6s;
}
@keyframes typing {
  0% {
    width: 5px;
    height: 5px;
  }
  50% {
    width: 7px;
    height: 7px;
  }
  100% {
    width: 5px;
    height: 5px;
  }
}
/**** Register ****/
.formContainer {
  margin-top: 10px;
  margin-left: -4px;
}
.inputContainer {
  margin-bottom: 4px;
}
.inputContainer input {
  border-radius: 15px;
  border: 1px solid #cacaca;
  padding: 3px;
  padding-left: 7px;
}
.helpbox {
  font-size: 12px;
  display: inline-block;
  width: 82%;
  line-height: 1.2em;
}
input[type="text"],
input[type="email"] {
  width: 100%;
}
input[type="submit"] {
  display: block;
  margin: auto;
  width: 66px;
  padding: 3px 12px 4px;
  border: 1px solid;
}
/**Checkboxes ***/
.new {
  margin-bottom: 5px;
}
.new:first-child {
  margin-top: 10px;
}
/* Hide the default checkboxes inside the 'new' div that jQuery adds for us */
.new input[type="checkbox"] {
  opacity: 0;
}

.new input[type="radio"] {
  opacity: 0;
}

/* jQuery adds this span for us which we style to look like a box */
.check-box {
  width: 16px;
  height: 16px;
  display: inline-block;
  cursor: pointer;
  margin-right: 10px;
  position: relative;
  top: 3px;
  margin-left: -10px;
  vertical-align: top;
}

/* When someone clicks our new box, add or remove the tick which has been created using some CSS */
[type="checkbox"]:checked + .check-box:before,
[type="radio"]:checked + .check-box:before {
  content: "";
  display: block;
  width: 5px;
  height: 12px;
  margin-left: 6px;
  border-style: solid;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  -webkit-transition: 0.1s;
  transition: 0.1s;
}
/* And change the background colour */
[type="checkbox"]:checked + .check-box,
[type="radio"]:checked + .check-box {
  transition: 0.5s;
}
</style>